<template>
    <main class="categoryWraps">

        <!-- 导航 -->
        <div class="breadWraps">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/tour' }">旅游</el-breadcrumb-item>
                <el-breadcrumb-item>{{ ActiveCaregotyLabel }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 搜索栏目 -->
        <div class="searchGroup">
            <div class="caregoryName">{{ ActiveCaregotyLabel }}</div>
            <el-input placeholder="请输入需要搜索的内容" v-model="searchValue" clearable class="searchInput"
                @clear="updateListData" @input="inputtingSearchValue">
                <el-button slot="append" icon="el-icon-search" @click="updateListData">搜索</el-button>
            </el-input>

        </div>


        <!-- 高级筛选栏目 -->
        <div class="filterGroupWraps">
            <div class="filterItem" v-for="(item, index) in filterTerm" :key="index">
                <p class="itemTitles">{{ item.title }}</p>
                <div class="filterChildren">
                    <div class="childs" v-for="(item2, index2) in item.filterItem"
                        :class="item.checkItem.includes(item2.value) ? 'tagsActive' : ''" :key="index2"
                        :data-item="item2.value" :data-keys="item.key" @click="chooseTagsItem">
                        {{ item2.label }}
                    </div>
                </div>
            </div>

            <!-- 其余筛选项 -->
            <div class="otherFilter">
                <div class="listOrderBtn" @click="setListOrderType('sold_quantity')">按销量排序
                    <span class="icon iconfont icon-paixu-jiang"
                        :class="salesSortType == 1 ? 'sortDesc' : salesSortType == 2 ? 'sortAsc' : ''"></span>
                </div>
                <div class="listOrderBtn" @click="setListOrderType('starting_price')">按价格排序
                    <span class="icon iconfont icon-paixu-jiang"
                        :class="priceSortType == 1 ? 'sortDesc' : priceSortType == 2 ? 'sortAsc' : ''"></span>
                </div>
            </div>
        </div>

        <!-- 列表容器 -->
        <div class="listWraps" v-loading="listLoadingStatus">
            <template v-if="productList.length">
                <div class="productItem " v-for="(item, index) in productList" :key="index"
                    @click="navTravelItemDetail(item.id)">
                    <div class="imgWrap">
                        <img :src="item.cover_url || loadFailImg" mode="aspectFill">
                    </div>
                    <div class="proRight flex-v-sbs">
                        <p class="proTitle">{{ item.name }}</p>
                        <div class="porSubname">{{ item.sub_name || '' }}</div>
                        <p class="proSummary">{{ item.summary }}</p>
                        <div class="proPrice"><span>{{ ConversionPrice(item.starting_price) || 0 }}</span> </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="noMoreData"><span>暂无更多数据</span></div>
            </template>

        </div>

        <!-- 页码模块 -->
        <div class="paginationWrap">
            <el-pagination background layout="prev, pager, next" :total="listTotalNum" :page-count="lastPageNum"
                :current-page="requestPageNum" @current-change="loadMoreListData">
            </el-pagination>
        </div>

    </main>
</template>

<script>
import $tour from '@api/tour';
import tool from '@assets/js/tool';

export default {
    components: {},
    data() {
        return {
            loadFailImg: require('@/assets/img/defaultImg.png'),
            listLoadingStatus: true, //列表数据加载中状态 
            ActiveCaregotyLabel: '',//当前产品分类的名称
            category_id: '',//类别Id
            baseDataInfo: {},//基础数据内容
            productList: [], //旅游产品列表
            searchValue: '',
            filterTerm: [],//筛选内容
            country_id: '',//请求接口的国家ID
            listTotalNum: 0,//列表接口请求的最大数据量 
            lastPageNum: 1,//列表接口请求最大页码 默认 1
            requestPageNum: 1, //请求接口的页码
            requestRowNum: 10,//请求接口的每个分页的数量 默认10条记录
            allTagsList: [],//所有选择的属性ID列表
            inputTimmer: null,//输入框 输入后 主动请求 定时器
            sortKey: '',//请求接口的 sort字段 默认为空 
            priceSortType: 0, // 价格排序模式 默认:0 无 ;1:降序(由大到小) ，2：升序(由小到大);
            salesSortType: 0,// 销量排序模式 默认:0 无 ;1:降序(由大到小) ，2：升序(由小到大);
        }
    },
    watch: {
        // 监听 选择的标签
        filterTerm: {
            async handler(param, oldParam) {
                let _this = this;
                if (param && Object.keys(param).length) {
                    let allTagsList = [];
                    param.map(item => {
                        if (item.key === 'countrys') {
                            _this.country_id = item.checkItem[0];
                        } else {
                            allTagsList.push(...item.checkItem);
                        }
                    });
                    _this.allTagsList = allTagsList;
                    await _this.updateListData();
                }
            },
            immediate: true,
            deep: true
        }
    },
    computed: {

    },
    async created() {
        let _this = this;
        const { category_id } = this.$route.params;
        if (!category_id) {
            this.$router.push({ name: 'tour' });
            return;
        }
        _this.category_id = category_id;
        _this.getCurrentCategoryName(category_id)
        await _this.getBaseData();
        await _this.getTravelProductList();
    },
    methods: {
        // 点击 销量 / 价格 排序
        async setListOrderType(type) {
            // priceSortType: 0, // 价格排序模式 默认:0 无 ;1:降序(由大到小) ，2：升序(由小到大);
            // salesSortType: 0,// 销量排序模式 默认:0 无 ;1:降序(由大到小) ，2：升序(由小到大);
            let _this = this;
            // 当前排序内容 与 上一次排序内容的排序字段相同时,需要切换排序模式
            if (_this.sortKey == type) {
                if (type == 'sold_quantity') {
                    if (_this.salesSortType == 2) {
                        _this.salesSortType = 0;
                        _this.sortKey = '';
                    } else {
                        _this.salesSortType += 1;
                    }
                } else {
                    if (_this.priceSortType == 2) {
                        _this.sortKey = '';
                        _this.priceSortType = 0;
                    } else {
                        _this.priceSortType += 1;
                    }
                }
            } else {
                _this.sortKey = type;
                if (type == 'sold_quantity') {
                    _this.salesSortType = 1;
                    _this.priceSortType = 0;
                } else {
                    _this.priceSortType = 1;
                    _this.salesSortType = 0;

                }
            }

            await _this.updateListData();

        },
        // 输入框输入事件
        inputtingSearchValue(e) {
            let _this = this;
            if (e) {
                if (_this.inputTimmer) clearTimeout(_this.inputTimmer);
                _this.inputTimmer = setTimeout(async () => {
                    _this.updateListData();
                }, 1000);
            }
        },

        // 加载更多数据
        async loadMoreListData(pageNum) {
            let _this = this;
            _this.requestPageNum = pageNum; //页码加1 
            await _this.getTravelProductList();

        },
        // 更新查询条件
        async updateListData() {
            let _this = this;
            _this.productList = [];
            _this.requestPageNum = 1; //重置页码; 
            await _this.getTravelProductList();
        },

        // 通过查询条件,获取产品列表
        async getTravelProductList() {
            let _this = this;
            _this.listLoadingStatus = true;

            const orderValue = !_this.sortKey ? '' : _this.sortKey == 'sold_quantity' ? _this.salesSortType : _this.priceSortType;
            const order = !orderValue ? '' : orderValue == 1 ? 'desc' : 'asc';
            const requestData = {
                category_id: _this.category_id,
                country_id: _this.country_id,
                keyword: _this.searchValue,
                page: _this.requestPageNum,
                rows: _this.requestRowNum,
                tag_ids: _this.allTagsList,
                // order: "",//order : desc || asc || ''
                sort: _this.sortKey,
                order: order
            }

            await $tour.getTravelListByCategory(requestData).then((res) => {
                if (res.status == 'success') {
                    _this.productList = res.data.data;
                    _this.lastPageNum = res.data.meta.last_page; //最大页码
                    _this.listTotalNum = res.data.meta.total;//最大数量
                    _this.listLoadingStatus = false;
                } else {
                    _this.listLoadingStatus = false;
                }
            })
        },

        // 判断当前路由id的旅游类型
        getCurrentCategoryName(id) {
            const caregoryList = [{ id: 10, label: '一日游' }, { id: 11, label: '半日游' }, { id: 64, label: '定制游' }, { id: 125, label: '跟团游' }];
            const targetCategory = caregoryList.find((item) => id == item.id) || null;

            if (targetCategory) {
                this.ActiveCaregotyLabel = targetCategory.label;
            }

        },
        // 通过参数ID,跳转到产品详情
        navTravelItemDetail(id) {
            this.$router.push({
                path: '/tour/' + id  // 假设 userId 是你要传递的参数
            });
        },
        // 将数字转为 正常显示的价格
        ConversionPrice(price) {
            return price ? (Number(price) / 100).toFixed(2) : 0;
        },

        // 通过分类ID获取 某个分类产品的基础数据
        async getBaseData() {
            let _this = this;
            await $tour.getCategoryBaseData(_this.category_id).then((res) => {
                if (res.status == 'success') {
                    _this.baseDataInfo = res.data;
                    _this.setFilterData(res.data);
                }
            })
        },
        // 设置筛选条件
        setFilterData(param) {
            let _this = this;
            let filterList = [];
            for (let i in param) {
                let filterItem = [];

                // 国家
                if (i == 'countrys') {
                    param[i].map(item => {
                        filterItem.push({
                            value: item.id,
                            label: item.text
                        });
                    });
                }
                if (i == 'sku_manual_confirmation') {
                    param[i].map(item => {
                        filterItem.push({
                            value: Number(item.value),
                            label: item.label
                        });
                    });
                }
                if (i == 'tags') {
                    param[i].map(item => {
                        filterItem.push({
                            value: item.id,
                            label: item.title
                        });
                    });
                }
                let filterGroup = {
                    key: i,
                    title: _this.getTitleByKey(i),
                    filterItem,
                    checkItem: []
                };
                filterList.push(filterGroup);
            }
            _this.filterTerm = filterList;
        },
        // 通过key值,返回 标题
        getTitleByKey(param) {
            switch (param) {
                case 'countrys':
                    return '国家';
                    break;
                case 'sku_manual_confirmation':
                    return '是否二次确认';
                    break;
                case 'tags':
                    return '标签';
                    break;
            }
        },
        // 选择标签
        chooseTagsItem(e) {
            let _this = this;
            const { keys } = e.target.dataset;
            const { item } = e.target.dataset;
            const value = Number(item);

            let dataList = JSON.parse(JSON.stringify(_this.filterTerm));
            dataList.map(item => {
                if (item.key == keys) {
                    if (item.checkItem.length) {
                        if (item.checkItem.includes(value)) {
                            item.checkItem = [];
                        } else {
                            item.checkItem = [value];
                        }
                    } else {
                        item.checkItem = [value];
                    }
                }
            });
            _this.filterTerm = dataList;

            if (keys == 'countrys') {
                _this.selectedCountry(value);
            } else {
                console.warn('选择其他~~~');
            }
        },
        // 选择国家标签时
        async selectedCountry(country_id) {
            let _this = this;
            await $tour.getDestinationsByCountry(country_id).then((res) => {
                if (res.status == 'success') {
                    if (res.data && res.data.length) {
                        let filterList = [];
                        let reg = new RegExp('[\u4E00-\u9FA5]+');
                        _this.filterTerm.map((item, index) => {
                            if (reg.test(item.key)) {
                                _this.filterTerm.splice(index, 1);
                            }
                        });
                        res.data.map(item => {
                            let filterItem = [];
                            if (item.children && item.children.length) {
                                item.children.map(item2 => {
                                    filterItem.push({
                                        value: item2.id,
                                        label: item2.title
                                    });
                                });
                            }

                            let filterGroup = {
                                key: item.title,
                                title: item.title,
                                filterItem,
                                checkItem: []
                            };
                            filterList.push(filterGroup);
                        });

                        let countrysIndex = 0;
                        _this.filterTerm.map((item, index) => {
                            if (item.key == 'countrys') countrysIndex = index;
                        });

                        filterList.map(item => {
                            _this.filterTerm.splice(Number(countrysIndex) + 1, 0, item);
                        });
                    } else {
                        let reg = new RegExp('[\u4E00-\u9FA5]+');
                        _this.filterTerm.map((item, index) => {
                            if (reg.test(item.key)) {
                                _this.filterTerm.splice(index, 1);
                            }
                        });
                    }
                }
            })

        },
        // ============end
    }
}
</script>

<style scoped src="./index.css"></style>